export const TUTORIALS_URL = "https://accidental-poultry-c8e.notion.site/Tutoriels-DR-33d688877dc980f28144f6f6a6382636?pvs=143";
export const IOS_TUTORIAL_URL =
  "https://www.loom.com/share/8b5a19b1e5074b20b3498ff4af4b52dc?sid=e98d19da-3f42-4320-a53d-a259fa5bc93f";
export const ANDROID_TUTORIAL_URL =
  "https://www.loom.com/share/ee50ed62f4c848808993edee2f41b712?sid=6eb08728-b823-4878-a82c-9d513752979c";
// v5 : note_configs[].categoryIds + Legend.categories (catalogues en liste de première
// classe) remplacent note_configs[].categories:string[] — voir backfill-legend-categories.ts.
export const LEGEND_VERSION = "5";

// Délai avant affichage du bandeau offline (4 jours)
export const OFFLINE_BANNER_DELAY_MS = 4 * 24 * 60 * 60 * 1000;

// Limite de dessins locaux avant affichage du bandeau de stockage
export const LOCAL_DRAWINGS_LIMIT = 200;

// Durée d'inactivité au-delà de laquelle un dessin local sans travail en attente
// est retiré du stockage hors ligne (aligné sur BACKUP_MAX_AGE_MS).
export const LOCAL_DRAWING_MAX_IDLE_MS = 60 * 24 * 60 * 60 * 1000; // 60 jours ≈ 2 mois

// Seuil d'utilisation du quota de stockage navigateur avant alerte (%)
export const STORAGE_QUOTA_WARNING_PERCENT = 90;

// Seuil de % du plafond mémoire JS (jsHeapSizeLimit) au-delà duquel proposer un rechargement (Chromium uniquement)
export const MEMORY_WARNING_PERCENT = 70;
// Marge de progression (points de %) avant réaffichage du bandeau après un dismiss
export const MEMORY_WARNING_REARM_PERCENT = 10;
// Repli en Mo de dérive cumulée pour les navigateurs sans jsHeapSizeLimit (Safari/iOS) — heuristique, pas de plafond de référence disponible
export const MEMORY_WARNING_FALLBACK_MB = 500;
// Marge de progression (Mo) avant réaffichage du bandeau après un dismiss, pour le repli
export const MEMORY_WARNING_REARM_FALLBACK_MB = 50;
